// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3j0mt","input":"styles_input__23WKt"};